import { render } from "./App.vue?vue&type=template&id=0cd19982"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0cd19982&lang=css"

import exportComponent from "I:\\VueProject\\xsd\\xsd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__